import { render } from "./MainPageDateSelector.vue?vue&type=template&id=1ae924a8&scoped=true&ts=true"
import script from "./MainPageDateSelector.vue?vue&type=script&lang=ts"
export * from "./MainPageDateSelector.vue?vue&type=script&lang=ts"

import "./MainPageDateSelector.vue?vue&type=style&index=0&id=1ae924a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae924a8"]])

export default __exports__